import styled from "styled-components";
import { TextBold } from "../../styles/GlobalStyledComponents";

export const CookiesPolicyContainer = styled.div`
    padding: 80px;
    line-height: 26px;

    @media screen and (max-width: 650px) {
        padding: 20px;
    }

    header {
        color: ${props => props.theme.colors.gray6};
        font-weight: 600;
        font-size: 14px;
        font-style: italic;
        margin-bottom: 15px;
    }

    footer {
        color: ${props => props.theme.colors.gray6};
        font-size: 12px;
        margin-top: 15px;
        text-align: center;
    }

    table {
        margin: 25px;
    }

    table, th, td  {
        border: solid 1px black;
        border-collapse: collapse;
        padding: 10px;
    }

    p {
        text-align: justify;
    }
`;

export const CookiesPolicyTitle = styled.p`
    padding: 20px 0;
    font-weight: 700;
`;

export const CookiesPolicyContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;


export const CookiesPolicyTextBold = styled.p`
    padding: 10px 0;
    font-weight: 600;
`;

export const CookiesPolicyImportantText = styled(TextBold)`
    text-decoration: underline;
`;